import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export type PaymentConnectionStatus =
  | 'not_connected'
  | 'draft'
  | 'active'
  | 'invalid'
  | 'disabled';

export interface PaymentConnection {
  id: string;
  provider: string;
  status: Exclude<PaymentConnectionStatus, 'not_connected'>;
  maskedHint: string | null;
  lastValidatedAt: string | null;
  lastValidationError: string | null;
}

export const usePaymentConnections = (enabled = true) => {
  const query = useQuery({
    queryKey: ['payments', 'connections'],
    queryFn: () => api.get<{ data: PaymentConnection[] }>('/payments/connections'),
    enabled,
  });

  const connections = query.data?.data ?? [];
  const connection = connections[0] ?? null;
  const status: PaymentConnectionStatus = connection?.status ?? 'not_connected';
  const isReady = connections.some((row) => row.status === 'active');

  return {
    ...query,
    connections,
    connection,
    status,
    isReady,
  };
};

/** First payment connection — enough for single-provider flows and link gating. */
export const usePaymentConnection = (enabled = true) => usePaymentConnections(enabled);
